import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  lubesResutlCardHanldeLikeState();
}

function lubesResutlCardHanldeLikeState() {
  document.addEventListener('click', (e) => {
    const button = e.target.closest('[data-au-lubes-result-card-like]');
    if (!button) return;

    const card = button.closest('[data-au-lubes-result-card]');
    const spanInButton = button.querySelector('[data-au-icon]');
    const buttonHiddenLabel = button.querySelector('[data-au-hidden-label]');
    const likeText = button.dataset.auLubesResultCardLike;
    const likedText = button.dataset.auLubesResultCardLiked;
    const brand = card.querySelector('[data-au-lubes-result-card-brand]').innerText;
    const model = card.querySelector('[data-au-lubes-result-card-model]').innerText;
    const displacement = card.querySelector('[data-au-lubes-result-card-displacement]').innerText;
    const year = card.querySelector('[data-au-lubes-result-card-year]').innerText;
    const fuelType = card.querySelector('[data-au-lubes-result-card-fuel-type]').innerText;
    const vehicle = `${brand} ${model} ${displacement} ${year} ${fuelType}`;
    const item_id = `favorito_${removeAccentMarkAndUppercase(vehicle)}`;

    // Toggle the filled class for the like icon
    spanInButton.classList.toggle('au-lubes-result-card__like-icon--filled');

    if (spanInButton.classList.contains('au-lubes-result-card__like-icon--filled')) {
      buttonHiddenLabel.textContent = likedText;
    } else {
      buttonHiddenLabel.textContent = likeText;
    }

    // datalayer
    window.dataLayer.push({
      event: 'navigation',
      content_type: 'clickIcono',
      item_id,
    });
  });
}

export default { init };
